import React from 'react';
import ReactDOM from 'react-dom';
import { Loading } from 'component';

let count = 0;
const showLoading = (show) => {
    if (show) {
        count += 1;
        if (!document.getElementById('api-loading')) {
            const el = document.createElement('div');
            el.id = 'api-loading';
            document.body.appendChild(el);
            ReactDOM.render(<Loading />, el);
            document.body.style.pointerEvents = 'none';
            setTimeout(() => {
                const modal = document.getElementsByClassName('ant-modal-content');
                for (let i = 0; i < modal.length; i += 1) {
                    modal[i].style.pointerEvents = 'none';
                }
            });
        }
    } else {
        count -= 1;
        setTimeout(() => {
            if (count === 0) {
                const el = document.getElementById('api-loading');
                if (el) {
                    document.body.removeChild(el);
                    document.body.style.pointerEvents = 'auto';
                    const modal = document.getElementsByClassName('ant-modal-content');
                    for (let i = 0; i < modal.length; i += 1) {
                        modal[i].style.pointerEvents = 'auto';
                    }
                }
            }
        });
    }
};

export default showLoading;
